/* PR-PERSONAL-2-FIX8 2026-05-24: modern slider styling с high specificity
   so browser-default + global input styles don't override. */
export const userBackgroundCSS = `
  /* Modern emerald opacity slider — used in Settings BackgroundImageSection.
     High specificity (input.bg-opacity-slider) + !important на key properties
     to defeat browser defaults + any global input styles. */
  input.bg-opacity-slider[type="range"] {
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    appearance: none !important;
    width: 100% !important;
    display: block !important;
    height: 8px !important;
    background: linear-gradient(to right,
      #10B981 0%,
      #10B981 var(--val, 50%),
      #E2E8F0 var(--val, 50%),
      #E2E8F0 100%) !important;
    border-radius: 999px !important;
    outline: none !important;
    transition: background 0.1s ease !important;
    cursor: pointer !important;
    padding: 0 !important;
    margin: 0 !important;
    border: none !important;
    box-shadow: inset 0 1px 2px rgba(0,0,0,0.06) !important;
  }
  input.bg-opacity-slider[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none !important;
    appearance: none !important;
    width: 24px !important;
    height: 24px !important;
    border-radius: 50% !important;
    background: #FFFFFF !important;
    border: 3px solid #10B981 !important;
    box-shadow: 0 3px 12px rgba(16,185,129,0.4), 0 1px 4px rgba(0,0,0,0.12) !important;
    cursor: pointer !important;
    transition: transform 0.15s ease, box-shadow 0.15s ease !important;
  }
  input.bg-opacity-slider[type="range"]::-webkit-slider-thumb:hover {
    transform: scale(1.15) !important;
    box-shadow: 0 5px 16px rgba(16,185,129,0.55), 0 2px 5px rgba(0,0,0,0.15) !important;
  }
  input.bg-opacity-slider[type="range"]::-webkit-slider-thumb:active {
    transform: scale(1.08) !important;
  }
  input.bg-opacity-slider[type="range"]::-moz-range-thumb {
    width: 24px !important;
    height: 24px !important;
    border-radius: 50% !important;
    background: #FFFFFF !important;
    border: 3px solid #10B981 !important;
    box-shadow: 0 3px 12px rgba(16,185,129,0.4), 0 1px 4px rgba(0,0,0,0.12) !important;
    cursor: pointer !important;
    transition: transform 0.15s ease !important;
  }
  input.bg-opacity-slider[type="range"]::-moz-range-thumb:hover {
    transform: scale(1.15) !important;
  }
  input.bg-opacity-slider[type="range"]::-moz-range-track {
    background: transparent !important;
    border: none !important;
    height: 8px !important;
  }
  input.bg-opacity-slider[type="range"]::-moz-range-progress {
    background: transparent !important;
  }
`;
